(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-pix/assets/route-play-pix.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-pix/assets/route-play-pix.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const ForEach = svs.components.lbUtils.reactConditionals.ForEach;
const PixItem = svs.components.tipsen.pixItem.PixItem;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_LG = _svs$components$lbUti.BREAKPOINT_LG,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const _svs$components$lbUi$ = svs.components.lbUi.carousel,
  Carousel = _svs$components$lbUi$.Carousel,
  CarouselItem = _svs$components$lbUi$.CarouselItem;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.engineSelectors,
  selectQuickPlayPixSizes = _svs$components$tipse.selectQuickPlayPixSizes,
  selectDefaultPixSize = _svs$components$tipse.selectDefaultPixSize,
  selectMinStake = _svs$components$tipse.selectMinStake;
const _svs$components$tipse2 = svs.components.tipsen.walletSelectors,
  selectActiveWallet = _svs$components$tipse2.selectActiveWallet,
  useWallets = _svs$components$tipse2.useWallets;
const WALLET_SELFSERVICE = svs.components.tipsen.wallet.walletType.WALLET_SELFSERVICE;
const WALLET_ID_PLAYER = svs.components.tipsen.wallet.walletId.WALLET_ID_PLAYER;
const _svs$components$tipse3 = svs.components.tipsen.walletComponent,
  WalletComponent = _svs$components$tipse3.WalletComponent,
  WalletAddition = _svs$components$tipse3.WalletAddition;
const _svs$components$marke = svs.components.marketplaceCompetition.services.selectors.competitionSelectors,
  selectCompetitionDraws = _svs$components$marke.selectCompetitionDraws,
  selectCompetition = _svs$components$marke.selectCompetition;
const getProductCompetitionId = svs.components.lbUtils.brandMapping.fn.getProductCompetitionId;
const getSystemSizeForSupportedCompetition = svs.components.tipsen.engine.utils.competitionHelpers.getSystemSizeForSupportedCompetition;
const CompetitionType = svs.components.marketplaceCompetition.constants.CompetitionType;
const useSetUpMarketplaceBalanceListener = svs.components.tipsen.couponId.useSetUpMarketplaceBalanceListener;
const useActionListener = svs.components.tipsen.hooks.useActionListener;
const SportTypes = svs.components.sport.sportTypes.SportTypes;
const RoutePlayPix = () => {
  useSetUpMarketplaceBalanceListener();
  const minStake = useSelector(state => selectMinStake(state));
  const quickPlayPixSizes = useSelector(state => selectQuickPlayPixSizes(state));
  const defaultPixSize = useSelector(state => selectDefaultPixSize(state));
  const indexOfDefaultPixSize = quickPlayPixSizes.indexOf(defaultPixSize);
  const draw = useCurrentDraw();
  const _ref = draw || {},
    drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    sportType = _ref.sportType;
  useActionListener();
  const isValidPixSportType = sportType !== SportTypes.Handball;
  const additionsGridClassNames = ['tipsen-additions-grid'];
  const isLarge = useMediaQuery(breakpoints.down(BREAKPOINT_LG));
  const isMedium = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const isAlmostMedium = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const carouselOptions = {};
  if (isMedium) {
    carouselOptions.itemsPerPage = 3;
  }
  if (isAlmostMedium) {
    carouselOptions.isMobile = true;
    carouselOptions.itemsPerPage = 1;
    if (indexOfDefaultPixSize > -1) {
      carouselOptions.selectedIndex = indexOfDefaultPixSize;
    }
  } else {
    additionsGridClassNames.push('additions-grid-pix');
  }
  const wallet = useSelector(selectActiveWallet);
  const isSelfserviceWallet = wallet && WALLET_SELFSERVICE === wallet.type;
  const wallets = useWallets();
  const hasOnlyPlayerWallet = wallets.length === 1 && wallets[0].id === WALLET_ID_PLAYER;
  const showWallet = !isSelfserviceWallet && wallets.length > 0 && !hasOnlyPlayerWallet;

  const competitionId = getProductCompetitionId(productId);
  const currentCompetition = useSelector(state => selectCompetition(state, competitionId));
  const drawsInCompetition = useSelector(state => selectCompetitionDraws(state, competitionId));
  const isCurrentDrawInCompetition = drawsInCompetition === null || drawsInCompetition === void 0 ? void 0 : drawsInCompetition.includes(drawNumber);
  const currentEngineDefintion = useSelector(selectEngineDefinition);
  let competitionSystemSize;
  let competitionType;
  let competitionBranding;
  if (currentCompetition && isCurrentDrawInCompetition) {
    competitionType = currentCompetition.compType;
    competitionBranding = currentCompetition.compType === CompetitionType.TipsEM ? 'tips-em' : 'tips-sm';
    competitionSystemSize = getSystemSizeForSupportedCompetition(currentEngineDefintion, currentCompetition);
  }
  const PixItemElement = _ref2 => {
    let index = _ref2.index,
      pixSize = _ref2.pixSize;
    return React.createElement(PixItem, {
      competitionBranding: pixSize === competitionSystemSize ? competitionBranding : undefined,
      competitionType: competitionType,
      draw: draw,
      drawNumber: drawNumber,
      index: index,
      isCompetition: pixSize === competitionSystemSize,
      key: index,
      productId: productId,
      rowPrice: minStake,
      systemCost: parseInt(pixSize, 10),
      wallet: wallet
    });
  };
  const GridElement = () => React.createElement("div", {
    className: "pg_route_play_pix__grid"
  }, React.createElement(ForEach, {
    array: quickPlayPixSizes,
    render: (pixSize, index) => {
      if (!pixSize) {
        return null;
      }
      const keyIndex = index + 1;
      return React.createElement(PixItemElement, {
        index: index,
        key: keyIndex,
        pixSize: pixSize
      });
    }
  }));
  return React.createElement("section", {
    className: "pg_route_play_pix"
  }, React.createElement("h2", {
    className: "tipsen-header f-center f-medium"
  }, "PIX! F\xE4rdiga spel"), React.createElement("p", {
    className: "pg_route_play_pix__subtitle"
  }, "".concat(isValidPixSportType ? 'Välj summa och köp spelet.' : 'För tillfället går det inte att spela PIX! på handboll.')), showWallet && React.createElement("div", {
    className: "tipsen-additions"
  }, React.createElement("div", {
    className: additionsGridClassNames.join(' ')
  }, React.createElement(WalletComponent, {
    Component: WalletAddition
  }))), isLarge && isValidPixSportType && React.createElement(Carousel, {
    className: "pg_route_play_pix__carousel",
    options: carouselOptions
  }, quickPlayPixSizes.map((pixSize, index) => {
    if (!pixSize) {
      return null;
    }
    const keyIndex = index + 1;
    return React.createElement(CarouselItem, {
      key: keyIndex
    }, React.createElement(PixItemElement, {
      index: index,
      pixSize: pixSize
    }));
  }).filter(Boolean)), !isLarge && isValidPixSportType && React.createElement(GridElement, null));
};
setGlobal('svs.components.tipsen.RoutePlayPix', RoutePlayPix);

 })(window);